module.exports = __webpack_public_path__ + "media/assets/information-934b7b88e0804a2540589d48dd46702fd4b2314cfc3946d14f97a19b53f99e95.svg";